import React from 'react'
import PhoneLink from './PhoneLink'

interface CardUserInfoProps {
  /** Full name combining first and last names **/
  name: string
  phone: string
}

/**
 * Generate initials using only the first letter of the first word
 * and the first letter of the last word in the full name.
 */
export const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return ''
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase()
  const firstInitial = parts[0].charAt(0)
  const lastInitial = parts[parts.length - 1].charAt(0)
  return (firstInitial + lastInitial).toUpperCase()
}

const CardUserInfo: React.FC<CardUserInfoProps> = ({name, phone}) => {
  return (
    <div className='d-flex align-items-center mb-3'>
      <div
        className='rounded-circle d-flex align-items-center justify-content-center me-3 bg-primary'
        style={{width: '48px', height: '48px'}}
      >
        <h1 className='text-white m-0 fs-3'>
          {getInitials(name)}
        </h1>
      </div>
      <div>
        <h1 className='h5 fw-bold mb-1 truncated-text'>{name}</h1>
        <PhoneLink phone={phone} />
      </div>
    </div>
  )
}

export default CardUserInfo
